const state = {
  stateoptionList: [],
  addStateOptionList: {},
  updateStateOptionList: {},
  deleteStateOptionList: {},
  sendStateOptionPriority: {},
};

export default state;
